<template lang="pug">
.video-card.white--text(@click="() => $router.push(to)")
  picture(v-ripple)
    img.elevation-1.rounded-sm(:src="img", :alt="title")
    .video-card-icon
      v-icon(color="", x-large) fab fa-youtube
    h5.font-weight-bold.px-2.text-uppercase {{ title }}
</template>

<script>
import { getYoutubeCode } from "@/components/utils.js";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    img() {
      return `https://i.ytimg.com/vi/${getYoutubeCode(
        this.link
      )}/mqdefault.jpg`;
    },
  },
};
</script>

<style>
.video-card {
  display: grid;
  grid-template-rows: 190px max-content max-content;
  grid-template-columns: 300px;
  cursor: pointer;
}
.video-card picture,
.video-card img {
  width: 100%;
  height: 100%;
}
.video-card picture {
  position: relative;
}
.video-card img {
  object-fit: cover;
}
.video-card-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(
    to top,
    #000000c9 0%,
    #00000066 20%,
    transparent 40%
  );
}
.video-card h5 {
  position: absolute;
  bottom: 8px;
  left: 0;
  width: 100%;
}
</style>
